import { Action } from 'redux'
import { isType } from 'ts-action'
import { IScreeningDocumentReducer, IScreeningDocument } from '../../models/ScreeningDocument'
import { updateArray } from '../../helpers/helperFunctions'
import {
  GetScreeningDocuments,
  ScreeningDocumentsFetching,
  UpdateScreeningDocument,
} from './actions'

const initialState: IScreeningDocumentReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const screeningDocumentsReducer = (
  state = initialState,
  action: Action
): IScreeningDocumentReducer => {
  if (isType(action, GetScreeningDocuments)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }

  if (isType(action, UpdateScreeningDocument)) {
    const { payload } = action
    const { data } = state
    const formattedArray = updateArray<IScreeningDocument>(data, payload.data)
    return {
      ...state,
      data: formattedArray,
    }
  }

  if (isType(action, ScreeningDocumentsFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  return state
}
